import { injectable } from 'inversify';
import type { IObjectViewModel } from '@/engine/app/interfaces';
import { LightenDarkenColor } from '@/engine/utils/colorUtils';

@injectable()
export class IndicationColorSetter {
  public setIndicationPointColor(pointViewModel: IObjectViewModel, color: string): void {
    if (!pointViewModel.setHighlightColor || !pointViewModel.setSelectionColor) {
      throw new Error('Indication point should have highlightColor and selectionColor setters!');
    }
    pointViewModel.setColor(color);
    pointViewModel.setSelectionColor(LightenDarkenColor(color, 10));
    pointViewModel.setHighlightColor(LightenDarkenColor(color, 10));
  }
}
